import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function NoNecesitasSection() {
  return <section className="bg-mp-dark py-24 md:py-36" data-id="element-230" data-mp="25fwwc2ux97ms">
      <Container className="text-center" data-id="element-231" data-mp="25edei7tmaoiw">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-232" data-mp="2afjb4gqeevxp">
          <p className="font-heading text-xs uppercase tracking-[0.25em] text-mp-gray" data-id="element-233" data-mp="1hr58tosa1dgc">No necesitas</p>
          <h2 className="mx-auto mt-4 max-w-[820px] font-heading text-3xl uppercase leading-[1.1] text-mp-white sm:text-4xl md:text-6xl" data-id="element-234" data-mp="1mo45adzexwhp">
            200 ejercicios más guardados en Instagram.
          </h2>
          <p className="mx-auto mt-6 max-w-[650px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-235" data-mp="u0rhk0hinimt">
            Necesitas saber qué enseñar, por qué enseñarlo, cómo corregirlo y qué viene después.
          </p>
          <p className="mt-10 font-heading text-4xl uppercase text-mp-lime sm:text-5xl md:text-6xl" data-id="element-236" data-mp="3dsnyisn778kf">
            Necesitas un sistema.
          </p>
        </motion.div>
      </Container>
    </section>;
}